import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

const CrossFitIcon: React.FC<IconSvgProps> = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.2608 15.091C18.2608 16.9453 17.4555 18.6109 16.1731 19.7583H7.82669C6.54432 18.6109 5.73901 16.9453 5.73901 15.091C5.73901 11.6332 8.54211 8.83008 11.9999 8.83008C15.4577 8.83008 18.2608 11.6332 18.2608 15.091Z"
      stroke={props.color}
      strokeWidth={1.5}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.23521 6.63749C7.96539 5.82807 8.56785 4.99219 9.42105 4.99219H10.8281H13.1718H14.5788C15.432 4.99219 16.0345 5.82807 15.7646 6.63749L14.8958 9.24378L16.3189 9.71814L17.1877 7.11185C17.7813 5.33113 16.4558 3.49219 14.5788 3.49219H13.1718H10.8281H9.42105C7.544 3.49219 6.21859 5.33113 6.81219 7.11185L7.68099 9.71814L9.10401 9.24378L8.23521 6.63749Z"
      fill={props.color}
    />
  </svg>
)
export default CrossFitIcon
